import { OverlayContainer } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { Component, HostListener, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';

export interface NavigationItem {
    path: string;
    label: string;
    icon?: string;
    exact?: boolean;
}

@Component({
    selector: 'pax-header',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, ButtonModule, NgClass],
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent {
    private readonly overlayContainer = inject(OverlayContainer);
    readonly showNavigation = input<boolean>(true);
    readonly navigationItems = input<NavigationItem[]>([]);
    sticky: boolean = true;

    isSticky: boolean = false;

    @HostListener('window:scroll')
    onWindowScroll() {
        if (!this.sticky) {
            this.isSticky = false;
            return;
        }

        // Don't update sticky state if a dialog is open
        if (this.overlayContainer.getContainerElement().children.length > 0) {
            return;
        }

        this.isSticky = window.scrollY > 100;
    }
}
